<template>
  <div v-if="this.$route.name != 'logintelegram' && this.$route.name != 'login' ">
    <v-app>
      <v-app-bar app class="red darken-0 white--text font-weight-black">
        <div class="d-flex align-center font-weight-white">

          <!-- Cam-Tool -->
        </div>
        <v-btn  v-if="this.$route.path != '/dashboard' " icon @click="backToDasboard()">
        <v-icon color="white">mdi-keyboard-backspace</v-icon>
        </v-btn>
        <v-spacer></v-spacer>

        <v-btn class=" white--text font-weight-black" text @click="logout()">

          <v-icon>mdi-power</v-icon>
          <!-- Logout -->
        </v-btn>

      </v-app-bar>

      <v-main>
        <router-view>

        </router-view>



      </v-main>

      <!-- <v-bottom-navigation :value="value" color="red" grow>
        <v-btn @click="goVideope()">
          <span>VideoPE</span>

          <v-icon>mdi-video</v-icon>
        </v-btn>


        <v-btn>
          <span>Setting</span>

          <v-icon>mdi-cog</v-icon>
        </v-btn>
      </v-bottom-navigation> -->
    </v-app>
  </div>
  <div v-else>

    <router-view>

    </router-view>

  </div>
</template>

<script>

export default {
  name: 'App',

  components: {

  },

  data: () => ({
    //
    IsLogin: false,
    value: 0
  }),
  methods: {

    goVideope() {

    this.$router.push('fb-videope').catch(err => {})
    },
    goToCreatePage() {
      this.$router.push('fb-create-page').catch(err => {})
    },
    async login() {

      const googleuser = await this.$gAuth.signIn();

      console.log("User", googleuser);

    },
    logout() {
      localStorage.removeItem('hasLogin')
      localStorage.removeItem('info')
      this.$router.push({ name: "login" });
      this.$store.commit("setAuthentication", false);
    }
    ,
    backToDasboard(){
      this.$router.push({ name: "dashboard" });
    }

  },

};
</script>

<style>
@font-face {
  font-family: 'Battambang';


  src: url("https://fonts.googleapis.com/css2?family=Battambang&display=swap");
}

* {
  font-family: Battambang;
}
</style>
